// Short labels (≤12 chars) for the User Group chip's role tag in the
// app-bar. The full names live in CONSTANTS.userTypeOptionsMap and are
// reused in the switcher dropdown rows where there is more horizontal room.
export const USER_TYPE_SHORT_LABELS = {
  admin: 'Admin',
  genetics: 'Service',
  geneticsServiceAdmin: 'Svc Admin',
  geneticsUser: 'User',
  student: 'Student'
};

// Deterministic fallback palette for the initials square shown when a User
// Group has no favicon. The same id always lands on the same colour because
// we hash the id and modulo into this list. Each swatch reads white text
// with AA contrast on the dark navbar and on the white dropdown surface.
export const USER_GROUP_FALLBACK_PALETTE = [
  '#2BA9BF', // TrakGene teal
  '#7F77DD', // purple
  '#D85A30', // coral
  '#1D9E75', // green
  '#185FA5', // blue
  '#993556', // pink
  '#BA7517', // amber
  '#534AB7' // deep purple
];

// Strips punctuation, picks the first letter of the first and last
// significant words. Falls back to '?' for unparseable names.
export function getUserGroupInitials(name) {
  if (typeof name !== 'string') return '?';
  const cleaned = name.replace(/[^\p{L}\p{N}\s]/gu, ' ').trim();
  const words = cleaned.split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

// Deterministic palette index derived from any id-like string. Sums char
// codes — fast, stable, and doesn't need a crypto hash for 8 buckets.
export function getUserGroupColour(id) {
  if (!id) return USER_GROUP_FALLBACK_PALETTE[0];
  const key = String(id);
  let sum = 0;
  for (let i = 0; i < key.length; i++) sum = (sum + key.charCodeAt(i)) >>> 0;
  return USER_GROUP_FALLBACK_PALETTE[sum % USER_GROUP_FALLBACK_PALETTE.length];
}
